import { optionsStatusSelect } from '@/app/utils/status'
import Select, { MultiValue } from 'react-select'
import { useFormContext } from 'react-hook-form'
import { FilterFormData } from './FilterReports'
import { useEffect, useState } from 'react'
import { OptionType } from '@/app/utils/optionSelectType'
import { FilterSelectStyle } from '@/view/components/BasicFilter/FilterSelectStyle'

export default function TransactionStatus() {
  const {
    setValue,
    formState: { errors },
    getValues,
  } = useFormContext<FilterFormData>()
  const [opt, setOpt] = useState<MultiValue<OptionType>>([])

  const fieldValue = getValues('status')
  useEffect(() => {
    if (!fieldValue) setOpt([])
    else
      setOpt(
        optionsStatusSelect.filter(({ value }) =>
          fieldValue?.includes(value),
        ) || [],
      )
  }, [fieldValue])

  const { DropdownIndicator, customStyles } = FilterSelectStyle({
    isMulti: true,
  })

  return (
    <div className="space-y-2">
      <h3 className="font-medium text-black04">Status</h3>
      <Select
        options={optionsStatusSelect}
        isMulti
        onChange={(d) => {
          const values = d?.map(({ value }) => value) ?? undefined
          setValue('status', values as unknown as string)
          setOpt(d)
        }}
        value={opt}
        placeholder="Selecione o(s) status"
        styles={customStyles}
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator,
        }}
      />
      {errors.status?.message}
    </div>
  )
}
